module.exports = __webpack_public_path__ + "img/11.4872689e.png";